var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"canvas",attrs:{"width":(_vm.p_width_n * _vm.p_wallSize_n) + 'px',"height":(_vm.p_height_n * _vm.p_wallSize_n) + 'px'}})}
var staticRenderFns = []

export { render, staticRenderFns }